/**
 * RoleBadge — small colored pill showing a user's member type.
 * Used across inbox, DMs, mention autocompletes, notifications, etc.
 */
import React from 'react';

const CONFIG = {
  driver:           { label: 'Driver',            cls: 'bg-blue-100 text-blue-700 border-blue-200' },
  carrier_owner:    { label: 'Carrier',           cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  dispatcher:       { label: 'Dispatcher',        cls: 'bg-violet-100 text-violet-700 border-violet-200' },
  learner:          { label: 'Learner',           cls: 'bg-orange-100 text-orange-700 border-orange-200' },
  service_provider: { label: 'Service Provider',  cls: 'bg-sky-100 text-sky-700 border-sky-200' },
  affiliate:        { label: 'Affiliate',         cls: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200' },
  admin:            { label: 'Admin',             cls: 'bg-red-100 text-red-700 border-red-200' },
};

export const RoleBadge = ({ role, size = 'sm', className = '' }) => {
  const c = CONFIG[role] || { label: role || 'Member', cls: 'bg-slate-100 text-slate-700 border-slate-200' };
  const sz = size === 'xs'
    ? 'text-[9px] px-1.5 py-0.5'
    : 'text-[10px] px-2 py-0.5';
  return (
    <span className={`inline-flex items-center border rounded font-semibold uppercase tracking-wider ${sz} ${c.cls} ${className}`}>
      {c.label}
    </span>
  );
};

export default RoleBadge;
